import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import "./Table.scss";
import moment from "moment";
import {
  awsget,
  awsupload,
  awsuploadfile,
  get,
  patch,
  put,
} from "../../../utils/api";
import { IconButton, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete"; // import delete icon
import Chip from "@mui/material/Chip";
import Pagination from "../Pagination/Pagination";
import { Link, useNavigate, useParams } from "react-router-dom";
import Checkbox from "@mui/material/Checkbox";
import TableAddNewIcon from "../../assets/images/Tabledata/add-new-btn.svg";
import TableEditIcon from "../../assets/images/Tabledata/edit-btn.svg";
import MaterialPagination from "../MaterialPagination/MaterialPagination";
import FieldSettingsIcon from "../../assets/images/Tabledata/field_settings_icon.svg";
import ColumnFieldSelect from "../ColumnFieldSelect";
import UploadIcon from "@mui/icons-material/Upload";
import { Button, TableSortLabel } from "@mui/material";
import SnackbarAlert from "../../../modules/common/sanckbar";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { DeleteForever } from "@mui/icons-material";
import DescriptionComponent from "../DescriptionComp/description";
import ConfirmationDialog from "../ConfirmationDialogBox/confirmation_box";

function Tabledata(props: any) {
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    // getnewsImage('hh')
  }, [props.module,props.data, props.primary_id]);

  console.log("props.table in table data", props);

  let data = props.data;
  console.log("data----------", data);
  console.log("folderame", props.folderName);
  let dataKeys: any[] = [];
  if (props.fields && props.fields.length > 0) {
    props.fields.map((e: any) => {
      if (e.coloumn_status) {
        dataKeys.push(e.key);
      }
    });
    dataKeys.push("actions");
  } else if (props.columns) {
    dataKeys = props.columns;
  } else if (data[0]) {
    dataKeys = Object.keys(data[0]);
    console.log("data", data);
    console.log("dataKeys", dataKeys);
  }
  console.log("tojo", dataKeys);

  const label = { inputProps: { "aria-label": "Checkbox demo" } };

  const showRightSideBar = (rowData: any) => {
    // if (props.rightSidebar) {
    //   props.showRightSidebar({status:false,data:rowData});
    // } else {
    props.showRightSidebar({ status: true, data: rowData });
    // }
  };

  // const getDirection = (key: string, sortBy: any) => {
  //   if (sortBy[key] == -1) {
  //     return "desc";
  //   } else {
  //     return "asc";
  //   }
  // };
  const getDirection = (key: string, sortBy: any) => {
    console.log(key,sortBy);
    if (!sortBy || typeof sortBy !== "object" || !sortBy[key]) {
      // console.error("Invalid or missing sortBy parameter:", sortBy);
      return "asc"; // Default direction if data is not available
    }
    return sortBy[key] === -1 ? "desc" : "asc";
  };
  // const getSortKey = (sortBy: any) => {
  //   let sortByAr = Object.keys(sortBy);
  //   return sortByAr[0];
  // };
  const getSortKey = (sortBy: any) => {
    // Check if sortBy is not null or undefined and is an object
    if (
      sortBy &&
      typeof sortBy === "object" &&
      Object.keys(sortBy).length > 0
    ) {
      let sortByAr = Object.keys(sortBy);
      return sortByAr[0];
    }
    return null; // or return a default sort key if appropriate
  };

  const handleWheel = (e: React.WheelEvent<HTMLDivElement>) => {
    const container = containerRef.current;
    if (container && e.deltaMode === 0) {
      const maxScrollLeft = container.scrollWidth - container.clientWidth;
      const shouldPreventScroll =
        (container.scrollLeft === 0 && e.deltaY < 0) ||
        (container.scrollLeft === maxScrollLeft && e.deltaY > 0);
      if (shouldPreventScroll) {
        e.preventDefault();
      }
    }
  };
  // const handleCheckbox = (e: any) => {
  //   console.log(e[props.primary_id]);
  //   console.log(props);
  //   const checkedItems = [...props.checked];
  //   let index = checkedItems.indexOf(e[props.primary_id]);
  //   if (index !== -1) {
  //     checkedItems.splice(index, 1);
  //   } else {
  //     checkedItems.push(e[props.primary_id]);
  //   }
  //   props.setChecked(checkedItems);
  //   console.log("props.checked", checkedItems);
  // };
  const handleCheckbox = (e: any) => {
    console.log("Current checked items: ", props.checked);
    if (!props.checked) {
      console.warn("Checked items array is undefined.");
      props.setChecked([]); // Initialize to empty if not already set
    } else {
      const checkedItems = [...props.checked];
      const index = checkedItems.indexOf(e[props.primary_id]);
      if (index !== -1) {
        checkedItems.splice(index, 1);
      } else {
        checkedItems.push(e[props.primary_id]);
      }
      props.setChecked(checkedItems);
    }
    console.log("Updated checked items: ", props.checked);
  };

  console.log("props.checked", props.checked);
  const navigate = useNavigate();

  const [snackbar, setSnackbar] = useState(false);
  const [alert_severity, setAlertSeverity] = useState("warning");
  const [alert_message, setMessage] = useState("");

  const alert = (message: string, alert_severity: string) => {
    setSnackbar(true);
    setMessage(message);
    setAlertSeverity(alert_severity);
  };

  const closeSnackbar = () => {
    // this.setState({ snackbar: false });
    setSnackbar(false);
  };

  const handleCheckboxAll = () => {
    props.setIsHeaderChecked(!props.isHeaderChecked);
    if (props.isHeaderChecked) {
      props.checked.splice(0, props.checked.length);
    } else {
      data.map((e: any) => {
        props.checked.push(e[props.primary_id]);
      });
    }
    console.log("props.setChecked", props.isHeaderChecked, props.checked);
  };
  console.log("props.setChecked", props.isHeaderChecked, props.checked);

  // ***********************************************************************************************
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedItem, setSelectedItem] = useState({}); // State to hold the selected item
  const [selectedItemType, setSelectedItemType] = useState(null); // State to hold the selected item

  const handleDeleteClick = (e: any, type: any) => {
    setSelectedItem(e);
    setSelectedItemType(type);

    setOpenDialog(true);
  };

  // Function to close the dialog without deleting
  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  function formatObjectAsHtmlList(obj:any) {
    let html = '<ul style="list-style: none; padding: 0; margin: 0;">';
    for (const [key, value] of Object.entries(obj)) {
        html += `<li><strong>${key}:</strong> ${value}</li>`;
    }
    html += '</ul>';
    return html;
}

function escapeHtml(text: string): string {
  const map: { [char: string]: string } = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
  };
  return text.replace(/[&<>"']/g, (m: string) => map[m] || m);
}

function formatObjectAsTooltip(obj: any): string {
  // Find a suitable key that's not an ID and whose value is not numeric
  const visibleKey = Object.keys(obj).find(key => 
      !key.toLowerCase().includes('id') && isNaN(obj[key])
  ) || 'N/A';

  // Obtain the value for the found key or default to 'N/A' if no suitable key is found
  const visibleValue = visibleKey === 'N/A' ? 'N/A' : obj[visibleKey];

  // Create a prettified version of the object for the tooltip, ensuring to escape it to prevent XSS
  const tooltipContent = JSON.stringify(obj, null, 2);

  // Return an HTML string with only the specified value visible, and the full object as a tooltip
  let html = `<span style="text-align: left; display: block;" title="${escapeHtml(tooltipContent)}">${escapeHtml(visibleValue.toString())}</span>`;
  return html;
}

  return (
    <>
      <SnackbarAlert
        open={snackbar}
        closeSnackbar={closeSnackbar}
        message={alert_message}
        severity={alert_severity}
      />
      <div
        className="row invoices-table-container"
        ref={containerRef}
        onWheel={handleWheel}
      >
        <div
          className="col-xs-12"
          style={{ paddingLeft: "0", paddingRight: "0" }}
        >
          <table className="table table-striped invoices-table">
            <thead className="thead-light thead-main">
              <tr>
                <>
                  <Checkbox
                    checked={props.isHeaderChecked}
                    className="d-flex"
                    {...label}
                    onChange={handleCheckboxAll}
                  />
                  {dataKeys.map((e: any, index: number) => {
                    return (
                      <th key={index} scope="col" className="table-headings">
                        <div>
                          <TableSortLabel
                            active={e === getSortKey(props.sortBy)}
                            direction={getDirection(e, props.sortBy)}
                            onClick={() => props.handleSortBy(e)}
                          >
                            <span>{e.replaceAll("_", " ").toLowerCase()}</span>
                          </TableSortLabel>
                        </div>
                      </th>
                    );
                  })}

                  <th>
                    <ColumnFieldSelect
                      className="fields-dropdown"
                      onClick={props.onClick}
                      buttonClass={props.buttonClass}
                      imagePath={FieldSettingsIcon}
                      color={props.color}
                      handleFieldStatus={props.handleFieldStatus}
                      fields={props.fields}
                      // customElement={props.customElement}
                    />
                  </th>
                </>
              </tr>
            </thead>
            <tbody>
              {data &&
                data.length > 0 &&
                data.map((e: any) => {
                  return (
                    // <tr onClick={() => showRightSideBar(e)} key={e.id}>
                    <tr
                      // onClick={() => setDetailViewModal(e)}
                      key={e[props.primary_id]}
                    >
                      {/* <th scope="row" key={e.id}>
                      {e.client_id}
                    </th> */}
                      <td className="text-center">
                        <Checkbox
                          className="form-check-input"
                          checked={
                            Array.isArray(props.checked) &&
                            props.checked.includes(e[props.primary_id])
                          }

                          onChange={() => handleCheckbox(e)}
                          {...label}
                          sx={{
                            paddingLeft: "13px",
                          }}
                        />
                      </td>

                      {dataKeys.map((e2: any) => {
                        let value = e[e2];

                        // Handle arrays by rendering a table
                        if (Array.isArray(value) && value.length > 0) {
                          const keys = Object.keys(value[0]);
                          value = (
                            <table className="table table-striped invoices-table">
                              <thead>
                                <tr>
                                  {keys.map(key => (
                                    <th key={key}>{key}</th>
                                  ))}
                                </tr>
                              </thead>
                              <tbody>
                                {value.map((row, idx) => (
                                  <tr key={idx}>
                                    {keys.map(key => (
                                      <td key={`${idx}-${key}`}>{typeof row[key] === 'object' ? JSON.stringify(row[key]) : row[key]}</td>
                                    ))}
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          );
                        }
                        // Handle objects (non-array)
                        else if (typeof value === "object" && value !== null) {
                          // value = (<pre>${JSON.stringify(value, null, 2)}</pre>)
                          value = <span dangerouslySetInnerHTML={{ __html: formatObjectAsTooltip(value) }} /> 
                          
                        }
                        // Handle date formatting
                        else if (e2.includes("date")) {
                          value = moment(value).format("DD-MMM-YYYY");
                        }
                        // Handle status field with Chip component
                        else if (e2 === "status") {
                          value =
                            e.status === "inactive" ? (
                              <Chip
                                label="Inactive"
                                color="primary"
                                sx={{
                                  height: "20px",
                                  bgcolor: "rgba(216, 106, 106, 0.32)",
                                  color: "#840A0A",
                                }}
                              />
                            ) : (
                              <Chip
                                label="Active"
                                color="primary"
                                sx={{
                                  height: "20px",
                                  bgcolor: "rgba(135, 216, 106, 0.32)",
                                  color: "#0A8442",
                                }}
                              />
                            );
                        }
                        // Handle action buttons with icons
                        else if (e2.includes("actions")) {
                          value = (
                            <div className="d-flex" title={props.primary_id}>
                              <button className="btn">
                                <Link
                                  to={props.detailLink + e[props.primary_id]}
                                >
                                  <img src={TableAddNewIcon} alt="Add" />
                                </Link>
                              </button>
                              <button className="btn">
                                <Link to={props.editLink + e[props.primary_id]}>
                                  <img src={TableEditIcon} alt="Edit" />
                                </Link>
                              </button>
                            </div>
                          );
                        }
                        // Handle image URL rendering
                        else if (e2.includes("image_url")) {
                          return (
                            <td style={{ padding: "10px" }} key={e2}>
                              <img
                                height="60px"
                                width="60px"
                                src={value}
                                alt="Image"
                              />
                            </td>
                          );
                        }
                        // Handle empty cases for specific fields like invoice_field_settings
                        else if (e2.includes("invoice_field_settings")) {
                          value = <div></div>;
                        }

                        return (
                          <td key={e2} scope="col">
                            {value}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
        {/* <MaterialPagination
        count={props.totalCount}
        page={props.page}
        handleChangePage={props.handleChangePage}
        rowsPerPage={props.page}
        handleChangeRowsPerPage={props.handleChangeRowsPerPage}
      /> */}
      </div>
    </>
  );
}

export default Tabledata;
